export default "/images/8ae22172912a8012a41ed1df3195541f.png";